module.exports = __webpack_public_path__ + "static/img/wt.6736e399.png";